import { NgRedux } from '@angular-redux/store';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { FilterByPipe } from 'ngx-pipes';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import {
  Building,
  IBuilding,
} from 'src/app/building-managment/building-management-interfaces';
import { FilterFloorsComponent } from 'src/app/floor-management/filter-floors/filter-floors.component';
import {
  BuildingFLoorUnit,
  Floor,
  IBuildingFloorUnit,
  IFloor,
} from 'src/app/floor-management/floor-management-interface';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import {
  IAppState,
  IFilterFloor,
  ISharedData,
} from 'src/app/shared/state-management/state-interfaces';
import { HelperService } from 'src/app/shared/utils/helper.service';
import {
  IUnitAndAccessPoint,
  IUnitDetail,
  IAccessDetail,
  IUserGroupDetails,
  IuserGroup,
} from '../../user-management-interfaces';
import { AddUserService } from '../add-user.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-building-listing',
  templateUrl: './building-listing.component.html',
  styleUrls: ['./building-listing.component.scss'],
  providers: [FilterByPipe],
})
export class BuildingListingComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  @Input() formGroupName!: string;
  @Input() stepper!: number;
  @Input() dialogRef?: any;
  @Output() stepperChange = new EventEmitter<number>();
  selectedUnitAccessPoint = {} as IUnitAndAccessPoint;
  @Input() alreadySelectedGroups?: string[] | undefined;
  @Output() selectedUnitAccessPointChange =
    new EventEmitter<IUnitAndAccessPoint>();
  @ViewChild('buildingListing') buildingListing!: ElementRef;
  buildingList!: Building;
  filter!: IFilterFloor;
  filterCount: number = 0;

  formGroup!: FormGroup;
  formGroupUserDetail!: FormGroup;
  submited = false;
  public toggleFormUnit = false;
  validateUnitAccessPoint = false;
  selectedBuilding: IBuilding | undefined;
  selectedSiteId?: String | null;
  floorUnits: any | undefined;
  TempHoldfloorUnits: any | undefined;
  selectedBuildingFloors: any[] = [];
  subscription: Subscription | undefined;
  sharedData?: ISharedData;
  markAll: boolean | undefined;
  appFloors!: Floor;
  readonly LANG_CONST = LANG_CONST;
  searchUnit: string | undefined;
  backupFloorUnits: any;
  noneSelected!: boolean;
  commonAccessControl!: boolean;
  addUserServiceSubscription: Subscription | undefined;
  builidngSubscription: Subscription | undefined;
  unitAndAccesspointSubscription: Subscription | undefined;
  @Input() userGroup?: IUserGroupDetails[] | undefined;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private stateManagementService: StateManagementService,
    private floorManagementService: FloorManagementService,
    private filterByPipe: FilterByPipe,
    private helperService: HelperService,
    private ngRedux: NgRedux<IAppState>,
    private addUserService: AddUserService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  /**
   * @description angular hook run after constructor
   * get userDetails formInstance for user first name and last name
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.stateSubscription();
    this.getAddUserServiceSubscription();
    this.selectedSiteId =
      this.stateManagementService.getSharedData()?.selectedSite?.siteId;
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
  }

  /**
   * @description #stateSubscription function gets the updated state variables
   *             from the store.
   * @returns void
   */
  stateSubscription() {
    this.commonAccessControl =
      this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.ngRedux.select('appData').subscribe((res: any) => {
      if (JSON.stringify(this.appFloors) !== JSON.stringify(res?.floors)) {
        this.appFloors = res?.floors;
      }
    });
  }

  /**
   * @description #getAddUserServiceSubscription function gets the updated list of not
   *              already selected
   * @returns void
   */

  private getAddUserServiceSubscription() {
    this.builidngSubscription = this.addUserService
      .getBuildingList()
      .subscribe((buildingList) => {
        if (buildingList) {
          this.buildingList = buildingList;
          this.checkSelected();
        }
      });
    this.selectedUnitAccessPoint =
      this.addUserService.getAlreadySelectedUnitAccessPoint();
  }

  /**
   * @description #checkSelected function gets the updated list of not
   *               already selected
   * @returns void
   */

  checkSelected() {
    const selectedGroups =
      this.userGroup?.filter((group: any) => {
        return !group.alreadySelected;
      }) || [];
    this.noneSelected =
      this.addUserService.getSelectedFloors().length === 0 &&
      selectedGroups?.length === 0
        ? true
        : false;
  }

  /**
   * @description #initializeFilter function gets the floorList from app and
   *               map the data int the required state of filter component.
   * @returns void
   */

  initializeFilter() {
    this.filter = {
      floors: this.appFloors,
      wings: [],
      floorsSelected: [],
      wingsSelected: [],
      filterType: CONSTANTS.BUILDING_LISTING,
    };
    this.filter.floors = this.appFloors?.map((floor: IFloor) => {
      return {
        ...floor,
        floorState: CONSTANTS.NOT_SELECTED,
        wingState: CONSTANTS.NOT_SELECTED,
      };
    });
    //null and empty value is handle here
    let emptyValueAppended = false;
    let uniqueWings: any = this.filter.floors
      ?.map((floor: IFloor) => floor?.wingName)
      .filter((value, index, self) => {
        if (!emptyValueAppended && (value === '' || value === null)) {
          emptyValueAppended = true;
          return true;
        }
        return value && self.indexOf(value) === index;
      });

    for (let i = 0; i < uniqueWings?.length; i++) {
      this.filter.wings.push({
        wingName: uniqueWings[i],
        wingState: CONSTANTS.NOT_SELECTED,
      });
    }
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   *
   * @param selectedBuilding building Id object
   * @description add building with unit
   * @returns void
   */
  addBuildingUnit(selectedBuilding: IBuilding): void {
    this.searchUnit = '';
    this.floorUnits = []; //empty before load new data
    this.TempHoldfloorUnits = []; //empty before load new data
    this.selectedBuildingFloors = []; //empty before load new data
    this.selectedBuilding = selectedBuilding;
    this.getFloorByBuildingId(selectedBuilding?.buildingId);
  }

  /**
   * @param buildingId selected building id
   * @description get floors and units given buildingid
   * @returns void
   */
  getFloorByBuildingId(buildingId: string): void {
    let finalise = new Subject();
    this.subscription = this.floorManagementService
      .getAllFloorsByBuildingId(this.selectedSiteId, buildingId)
      .pipe(
        takeUntil(finalise),
        mergeMap((floors: Floor) => {
          floors?.map((floor: IFloor) =>
            this.selectedBuildingFloors.push({
              floorName: floor?.floorName,
              floorId: floor?.floorId,
              wingName: floor?.wingName,
            })
          ); // hold ids to merge into unit

          let floorObservables = floors?.map((floor: IFloor) =>
            this.floorManagementService.getUnitsAndAccessPointsByFloor(
              this.selectedSiteId,
              buildingId,
              floor?.floorId
            )
          );
          return forkJoin(floorObservables);
        })
      )
      .subscribe({
        next: (unitsAndAccesspoints: any) => {
          this.toggleFormUnit = !this.toggleFormUnit;

          unitsAndAccesspoints?.map((unitAndAccesspoint: any, i: number) => {
            if (unitAndAccesspoint.length) {
              unitAndAccesspoint.floorName =
                this.selectedBuildingFloors[i].floorName;
              unitAndAccesspoint.wingName =
                this.selectedBuildingFloors[i].wingName;
              unitAndAccesspoint.buildingId = this.selectedBuilding?.buildingId;
              unitAndAccesspoint.buildingName =
                this.selectedBuilding?.buildingName;
              return unitAndAccesspoint.map((unitOrAccessPoint: any) => {
                unitOrAccessPoint.floorId =
                  this.selectedBuildingFloors[i].floorId;
                if (unitOrAccessPoint?.unitId) {
                  unitOrAccessPoint.unitName = `${this.translate.instant(
                    'UNIT'
                  )} ${unitOrAccessPoint.unitName}`;
                }
                unitAndAccesspoint.map((unit: any) => {
                  unit.buildingId = buildingId;
                  unit.buildingName = this.selectedBuilding?.buildingName;
                  unit.status = false;
                  unit.siteId = this.sharedData?.selectedSite?.siteId;
                });
              });
            }
          });

          this.addUserService.setFloorUnits(unitsAndAccesspoints);
          this.floorUnits = this.addUserService.getFloorUnits();
          this.preSelctedFloorUnit();
          this.preSharedFloorUnit();
          this.checkAllMarkUnits();
          this.initializeFilter();
          this.filterCount = 0;
          /**
           * self unsubscribing observable by using takeUntil
           */
          finalise.next();
          finalise.complete();
        },
        error: (err: Error) => {
          this.toggleFormUnit = !this.toggleFormUnit;
          if (window.__dev__) console.log('getFloorByBuildingId', err);
        },
      });
  }

  /**
   * @description load time check if any units selected checked mark
   * @return void
   */
  preSharedFloorUnit(): void {
    this.floorUnits?.flat().map((floorUnit: any) => {
      if (
        this.addUserService.hasAlreadySharedEntities(
          floorUnit.unitId || floorUnit.accessPointId
        )
      ) {
        floorUnit.status = true;
        floorUnit.alreadySelected = true;
      }
    });
  }

  /**
   * @description load time check if any units selected checked mark
   * @return void
   */

  preSelctedFloorUnit(): void {
    this.floorUnits?.flat().map((floorUnit: any) => {
      if (
        this.addUserService.hasSelectedEntity(
          floorUnit.unitId || floorUnit.accessPointId
        )
      ) {
        floorUnit.status = true;
      }
    });
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    this.submited = true;
    if (this.noneSelected) return;
    this.stepperChange.emit((this.stepper += 1));
  }

  ngAfterViewChecked(): void {
    if (this.buildingListing && this.buildingListing.nativeElement) {
      this.buildingListing.nativeElement.focus();
    }
  }
  /**
   * @description reset toggle form based on selected building
   * @returns void
   */
  resetToggleFormState(): void {
    this.toggleFormUnit = false;
    this.searchUnit = '';
  }

  /**
   * @param unit current unit id
   * @description update unit status
   * returns void
   */
  updateUnitStatus(entity: any): void {
    this.floorUnits?.flat().map((floorUnit: any) => {
      if (floorUnit?.unitId && floorUnit?.unitId === entity?.unitId) {
        return (floorUnit.status = !floorUnit.status);
      } else if (
        floorUnit?.accessPointId &&
        floorUnit?.accessPointId === entity?.accessPointId
      ) {
        return (floorUnit.status = !floorUnit.status);
      }
    });
    this.checkAllMarkUnits();
    this.validateUnitAccessPointSubmit();
  }

  /**
   * @description toggle check if all selected set value true else false
   * @returns void
   */
  checkAllMarkUnits(): void {
    this.floorUnits.flat().filter((floorUnit: any) => {
      return floorUnit?.status !== true;
    })?.length === 0
      ? (this.markAll = true)
      : (this.markAll = false);
  }

  /**
   * @returns array of FloorUnitsAndAccessPoints
   * @description Units and Accesspoints by search key work
   */
  filterUnitsAndAccessPointsBySearch(): any {
    return this.filterByPipe.transform(
      this.floorUnits?.flat(),
      ['unitName', 'accessPointName'],
      this.searchUnit
    );
  }

  /**
   * @description any of unit or even access point select submit button unable
   * @returns void
   */
  validateUnitAccessPointSubmit(): void {
    this.validateUnitAccessPoint = this.floorUnits
      ?.flat()
      .some((floor: any) => floor.status === true && !floor.alreadySelected);
  }

  /**
   * @description add new units
   * @returns void
   */
  addUnit(): void {
    this.toggleFormUnit = !this.toggleFormUnit;
    this.addUserService.setSelectedFloorUnits(this.floorUnits.flat());
    const updatedCount = this.addUserService.getUpdetedBuildingCount();
    this.buildingList?.map((x: any) => {
      if (x.buildingId === this.selectedBuilding?.buildingId) {
        x.count = updatedCount;
      }
    });
    this.addUserService.setBuildingList(this.buildingList);
    this.checkSelected();
  }

  /*
   * @description get selected floor units
   * @returns array of selected floor units
   *
   */
  getSelecteFloorUnits(): any {
    const selectedFloorUnits = this.floorUnits?.flat().filter((floor: any) => {
      return floor.status === true && !floor.alreadySelected;
    });
    return selectedFloorUnits;
  }

  /**
   * @description select unselect all list item
   * @returns void
   */
  markList() {
    if (this.searchUnit) {
      this.floorUnitsUpdateStatus();
    } else {
      this.floorUnits?.map((floorUnit: any) => {
        floorUnit?.map((unit: any) => {
          if (!this.commonAccessControl) {
            if (!unit?.alreadySelected && unit.unitId) {
              unit.status = this.markAll;
            }
          } else {
            if (!unit?.alreadySelected) {
              unit.status = this.markAll;
            }
          }
        });
      });
    }

    this.validateUnitAccessPointSubmit();
  }

  /**
   * @description Update units status as per search key
   * @returns void
   */
  floorUnitsUpdateStatus(): void {
    const filterUnits = this.filterUnitsAndAccessPointsBySearch();

    filterUnits?.map((filterUnit: any) => {
      const floorIndex = this.floorUnits
        ?.flat()
        ?.findIndex((unit: any) => unit === filterUnit);
      if (floorIndex != -1 && floorIndex != undefined) {
        this.floorUnits.flat()[floorIndex].status = this.markAll;
      }
    });
  }

  /**
   * @param ev selected value
   * @description search any keyword
   * @returns void
   */
  searchUnitsEvent(ev: string): void {
    this.searchUnit = ev;
    this.checkAllMarkUnits();
  }

  /**
   * @description: onFilterUnit function function opens the modal poup for Edit unit.
   * @input none
   * @output { void }
   */

  onFilterUnit() {
    const dialogRef = this.helperService.openModalDialog(
      FilterFloorsComponent,
      this.filter,
      [CONSTANTS.FIXED_SCREEN_MODAL]
    );

    dialogRef
      ?.afterClosed()
      .subscribe((filterFloors: IFilterFloor | undefined) => {
        if (filterFloors) {
          this.filter = filterFloors;
          this.filterCount =
            this.filter?.floorsSelected.length +
            this.filter?.wingsSelected.length;
          this.floorUnits = this.addUserService.getFilteredFloorUnits(
            filterFloors?.floorsSelected,
            filterFloors?.wingsSelected
          );
          this.checkAllMarkUnits();
        } else {
          this.filterCount = 0;
          this.floorUnits = this.addUserService.getFloorUnits();
          this.checkAllMarkUnits();
        }
      });
  }

  /**
   * @description angular hook call when angular unmount component
   * @returns void
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.builidngSubscription?.unsubscribe();
    this.unitAndAccesspointSubscription?.unsubscribe();
  }
}
